/*
 * Lib Module Autocompletes

 */

class Autocomplete {

    clear(autocompleteInput) {
        autocompleteInput.typeahead('val', '');
        autocompleteInput.val('');
    }

    set(autocompleteInput, val) {
        autocompleteInput.typeahead('val', val);
    }

    refresh(autocompleteInput) {
        var oldValue = autocompleteInput.val();
        this.clear(autocompleteInput);
        this.set(autocompleteInput, oldValue);
        autocompleteInput.focus();
    }

    /**
     * Create autocomplete
     *
     * @param autocompleteInput
     * @param options_
     * @returns {boolean}
     */
    create(autocompleteInput, options_) {

        // First overrule the data attribute options with the passed options
        // In this case the passed options in the function are more important than the data attribute options
        var options = $.extend(true, autocompleteInput.data('autocomplete'), options_);
        // Now set some default options that we NEED
        options = $.extend(true, {
            url: false,
            type: 'POST',
            data: {},
            selectKey: '',
            selectCallback: function() {
                return true;
            },
            filter: false,
            template: function() {
                return 'Please provide a template';
            },
            disableEnter: true,
            minLength: 2,
            rateLimitWait: 800,
            limit: 15,
        }, options);

        // Disable submitting the form on enter, if enabled
        if (options.disableEnter === false) {
            Lib.Form.forceEnterSubmit(autocompleteInput);
        }

        // Check if a url is provided
        if (!options.url) {
            Lib.Debug.warn('No url provided for autocomplete');
            return false;
        }

        // Setup bloodhound
        var remote = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                filter: options.filter,
                rateLimitWait: options.rateLimitWait,
                url: options.url,
                ajax: {
                    cache: false,
                },
                prepare: function(jqXHR, settings) {
                    settings.type = options.type;

                    if (typeof options.data === 'function') {
                        options.data = options.data();
                    }

                    var elementData = $.extend(true, options.data, autocompleteInput.data('autocompleteData'));

                    settings.data = $.extend(true, {
                        term: autocompleteInput.val()
                    }, elementData);

                    return settings;
                }
            }
        });

        // Cache if the autocomplete is focussed before we start
        var isFocussed = autocompleteInput.is(':focus');
        // initialize typeahead
        autocompleteInput.typeahead({minLength: options.minLength}, {
            source: remote.ttAdapter(),
            minLength: options.minLength,
            async: true,
            hint: false,
            limit: options.limit,
            displayKey: options.selectKey,
            templates: {
                empty: '<div class="tt-suggestion">Helaas, er zijn geen resultaten</div>',
                suggestion: options.template
            }
        });

        autocompleteInput.on('typeahead:selected', function(e, data) {
            autocompleteInput.parent().find('.tt-menu .tt-dataset .tt-suggestion').remove();
            autocompleteInput.typeahead('val', data[options.selectKey]);
            autocompleteInput.blur();
        });

        autocompleteInput.on('typeahead:selected', options.selectCallback);

        autocompleteInput.on('typeahead:cursorchange', function(e, data) {
            autocompleteInput.val(data[options.selectKey]);
        });

        autocompleteInput.on('typeahead:asyncrequest', function() {


            if (autocompleteInput.val().length > options.minLength) {
                // Show loader
                autocompleteInput.parent().addClass('autocomplete-loader');
            }
        });

        autocompleteInput.on('typeahead:asyncreceive', function() {
            // hide loader
            autocompleteInput.parent().removeClass('autocomplete-loader');
        });

        autocompleteInput.on('typeahead:close', function() {
            // hide loader
            autocompleteInput.parent().removeClass('autocomplete-loader');
        });

        autocompleteInput.on('autocomplete.clear', () => {
            this.clear(autocompleteInput);
            autocompleteInput.parent().removeClass('autocomplete-loader');
        });

        // Refocus if it was focussed before
        if (isFocussed) {
            autocompleteInput.focus();
        }
    }

}

// Expose in Lib
Lib.Autocomplete = new Autocomplete;
